import { useNotData, useData } from "./useNotShowPublicLogic";
import type { ForceModalData } from "./useNotShowPublicLogic";
import { getWebDomain } from '@/utils/app'
import router from "@/router";
import { uesShowForceModal } from "./useShow"
import { registerRewardInfoApi } from "@/api/normal"
import { isEmpty } from "lodash-es";
import { SD_MODEL } from '@/enums/device'
export const registerRewardForceModal = async () => {
  const systemStore = useSystemStore()
  const userStore = useUserStore();
  const notUseDataShowMap = useNotData()
  //注册赠送需要添加 注册的奖金领取没有活着没有参与不弹框  
  notUseDataShowMap.set('unableParticipate', () => !userStore.user?.canUseRegisterRewardInfo)
  let isNotShow = [...notUseDataShowMap.values()].some(fn => fn())
  console.log( [...notUseDataShowMap.values()],isNotShow, 'isNotShow');

  if (isNotShow) return false

  const isLogin = await useAppStore().checkUserHasLogin();
  if (!isLogin) return false

  const registerRewardInfo = await registerRewardInfoApi()
  if (isEmpty(registerRewardInfo)) return false
  const { frontConfig, rewardSwitch } = registerRewardInfo as { frontConfig: string; rewardSwitch: boolean }


  let parsedConfig = {}
  try {
    parsedConfig = JSON.parse(frontConfig) as Record<string, any>
    console.log(parsedConfig, 'registerRewardInfo')
  } catch (error) {
    console.log('解析失败', error)
  }
  if (isEmpty(parsedConfig)) return false

  const currentConfig = systemStore.app?.build === SD_MODEL.IOS_H5 ? (parsedConfig as { ios?: any })?.ios : (parsedConfig as { android?: any })?.android

  const channelStore = useChannelStore(); // 渠道信息 
  const tenantStore = useTenantStore()
  const route = router.currentRoute
  const ch = (route.value.query.ch || 0) as number
  await channelStore.reqChannelInfo({
    id: ch,
    tenantId: tenantStore.tenantId || 0,
    domain: getWebDomain(),
  })
  const expireDate = await channelStore.getCompulsoryInstallTime('registerReward')
  const params: ForceModalData = {
    popupTime: currentConfig?.popupTime,
    installType: currentConfig?.installType,
    guideInstall: currentConfig?.guideInstall,
    popupInterval: Number(currentConfig?.popupInterval) || 0,
    expireDate,
    isNotOpen: !rewardSwitch
  }

  isNotShow = [...useData(params).values()].some(fn => fn())
  if (isNotShow) return false
  channelStore.promotionInfo = {
    ...(channelStore?.promotionInfo || {}),
    ...currentConfig
  }

  return uesShowForceModal('registerReward')
}
